import { render, staticRenderFns } from "./shipment-form.vue?vue&type=template&id=35f40149&scoped=true"
import script from "./shipment-form.vue?vue&type=script&lang=js"
export * from "./shipment-form.vue?vue&type=script&lang=js"
import style0 from "./shipment-form.vue?vue&type=style&index=0&id=35f40149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f40149",
  null
  
)

export default component.exports